/* eslint-disable max-len */
import { Button, Container } from "react-bootstrap";
import { Route, Routes, useParams } from "react-router";

import "./Courses.scss";
import CourseSeries from "./CourseSeries";
import CourseSingle from "./CourseSingle";
import LwcErrorBoundary from "../../components/LwcErrorBoundary";
import PageHeader from "../../components/PageHeader";
import RegistrationAccordion from "../../components/RegistrationAccordion/RegistrationAccordion";
import { hasRole } from "../../services/wp.user.service";

const CourseLayout = () => {
	const { courseId } = useParams();

	return (
		<>
			<PageHeader fluid showBack title="Class">
				{hasRole("administrator") && !!courseId && <Button href={`/wp-admin/post.php?action=edit&post=${courseId}`}>Edit</Button>}
			</PageHeader>

			<Container fluid id="main">
				<LwcErrorBoundary>
					<Routes>
						<Route element={<CourseSeries />} path="/series/:seriesId" />
						<Route element={<CourseSingle />} path="/:courseId" />
						<Route element={<CourseSingle />} path="/*" />
					</Routes>
				</LwcErrorBoundary>
			</Container>

			<RegistrationAccordion />
		</>
	);
};

export default CourseLayout;
